// const sampleInputData = {
//   customerNumber: 1005,
//   version: '0.0.0.0',
//   number: 39033,
//   modeOfSale: 3,
//   fees: [
//     {
//       description: 'Taxes &amp; Fees:',
//       amount: 30.5,
//     },
//   ],
//   total: 120.5,
//   cartItems: [
//     {
//       id: 71824,
//       productId: 5198,
//       performanceId: 5198,
//       packageId: 0,
//       price: 90,
//       priceType: 2,
//       priceTypeDescription: 'Adult',
//       productType: 'Single Tix',
//       productDescription: 'Alvin Ailey American Dance Override',
//       quantity: 1,
//     },
//   ],
// };

class GoogleDataLayerProvider {
    constructor(data = {}) {

        const googleDataLayerDefaults = {
            customerNumber: 0,
            version: window.tnew.app.appVersion.toString(),
            isVersionSevenEnabled: true,
            cartItems: [],
            fees: [],
            isGuest: false,
            isAnonymous: true
        };

        this.data = Object.assign(googleDataLayerDefaults, data);
    }

    getSession() {

        const data = this.data;

        return {
            session: {
                version: data.version,
                isVersionSevenEnabled: data.isVersionSevenEnabled,
                customer: {
                    id: data.customerNumber,
                    isGuest: data.isGuest,
                    isAnonymous: data.isAnonymous
                }
            }
        };
    }

    transformOrder() {

        if (this.data.cartItems.length === 0) {
            return {}
        }

        const convertedProducts = this.convertProducts();
        const totalFees = this.sumFees();
        const data = this.data;

        return {
            transactionId: data.number,
            transactionAffiliation: data.modeOfSale,
            transactionTotal: data.total,
            transactionTax: 0,
            transactionProducts: convertedProducts,
            transactionShipping: totalFees
        };
    }

    convertProducts() {
        const products = {};
        const cartItems = this.data.cartItems;

        cartItems.forEach((cartItem) => {

            const key = `${cartItem.productId}-${cartItem.priceType}-${cartItem.price}`;

            if (products[key]) {

                products[key].quantity += cartItem.quantity;

            } else {

                products[key] = {
                    sku: this.buildSku(cartItem),
                    name: cartItem.productDescription,
                    category: cartItem.productType,
                    price: cartItem.price,
                    quantity: cartItem.quantity
                };
            }
        });

        return Object.values(products);
    }

    sumFees() {
        return this.data.fees.reduce((sum, fee) => sum + fee.amount, 0);
    }

    buildSku(cartItem) {

        if (cartItem.productType === 'Contribution') {
            return `${cartItem.productId}|${cartItem.id}`;
        }

        const id = (cartItem.productId) ? cartItem.productId : cartItem.id;
        const skuElements = [id, cartItem.priceTypeDescription, cartItem.priceType, cartItem.price];

        return skuElements.filter(el => !!el).join('|');
    }
}

export default GoogleDataLayerProvider;



// WEBPACK FOOTER //
// ./V7/tnew/lib/GoogleDataLayerProvider.js